import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/ProCalculatorSignInPrompt.css';

const ProCalculatorSignInPrompt = () => {
  const { signInWithGoogle, signInWithEmail } = useAuth();
  const navigate = useNavigate();

  const handleSignIn = async (method) => {
    try {
      // Store the intended destination
      localStorage.setItem('postLoginRedirect', '/pro');
      
      if (method === 'google') {
        await signInWithGoogle();
      } else if (method === 'email') {
        navigate('/signin', { state: { from: '/pro' } });
      }
    } catch (error) {
      console.error('Sign in error:', error);
    }
  };

  return (
    <div className="pro-signin-prompt">
      <h1>Welcome to Pro Calculator</h1>
      <div className="pro-signin-content">
        <p className="feature-highlight">
          🎉 Currently Free During Beta! 🎉
        </p>
        <p className="description">
          Access our powerful Pro Calculator to manage complex cookie decorating projects with ease.
          Simply sign in to get started - no subscription required during our beta period!
        </p>
        <div className="features-list">
          <h2>Pro Features Include:</h2>
          <ul>
            <li>🍪 Multiple cookie type management</li>
            <li>📏 Precise dimension calculations</li>
            <li>🎨 Color percentage tracking</li>
            <li>📦 Set creation and organization</li>
            <li>📊 Detailed results and analytics</li>
          </ul>
        </div>
        <div className="signin-buttons">
          <button 
            className="signin-button google"
            onClick={() => handleSignIn('google')}
          >
            Sign in with Google
          </button>
          <button 
            className="signin-button email"
            onClick={() => handleSignIn('email')}
          >
            Sign in with Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProCalculatorSignInPrompt;
